import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  ref: "popup",
  class: "group fixed left-1/2 top-1/2 m-0 grid place-items-center pointer-events-none opacity-0 -translate-x-1/2 -translate-y-1/2 size-full bg-transparent transition-opacity duration-300 open:pointer-events-auto open:opacity-100 backdrop:bg-base-500/60"
}
const _hoisted_2 = { class: "flex flex-col md:flex-row items-center gap-3 mx-auto max-md:w-full md:max-w-[340px]" }

import { useTemplateRef } from 'vue';
import Button from '../base/Button.vue';

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'Popup',
  props: {
    cancelButtonText: {},
    cancelButtonType: { default: 'secondary' },
    confirmButtonText: {},
    confirmButtonType: { default: 'primary' },
    size: { default: 'normal' },
    loading: { type: Boolean, default: false }
  },
  emits: ["popupConfirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {



// Emits
const emit = __emit;

// Store popup in ref
const popupRef = useTemplateRef('popup');

// Open popup
const openPopup = () => {
    popupRef.value.showModal();
};

// Close popup
const closePopup = () => {
    popupRef.value.close();
};

// Expose both functions to the parent
__expose({ openPopup, closePopup });

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("dialog", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass([
                'flex flex-col items-center gap-7 w-full max-w-[600px] bg-white -translate-y-16 group-open:translate-y-0 transition-transform duration-300',
                _ctx.size === 'normal' && 'px-6 md:px-10 py-8 md:py-12',
                _ctx.size === 'small' && 'p-6 ',
            ])
    }, [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.cancelButtonText)
          ? (_openBlock(), _createBlock(Button, {
              key: 0,
              class: "max-md:w-full",
              text: _ctx.cancelButtonText,
              type: _ctx.cancelButtonType,
              onClick: _withModifiers(closePopup, ["prevent"])
            }, null, 8, ["text", "type"]))
          : _createCommentVNode("", true),
        _createVNode(Button, {
          class: "max-md:w-full",
          text: _ctx.confirmButtonText,
          type: _ctx.confirmButtonType,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('popupConfirm')), ["prevent"]))
        }, null, 8, ["text", "type"])
      ])
    ], 2)), [
      [_directive_loading, _ctx.loading]
    ])
  ], 512))
}
}

})